import React, {Component} from 'react';
import * as R from 'ramda';
import classNames from 'classnames';
import {Link} from 'react-router';

import './index.scss';

export default class Button extends Component {
    static defaultProps = {
        onClick: () => {}
    };

    constructor(props) {
        super(props);
        this.state = {
            showOptions: false
        };
    }

    hasOptions() {
        const {options} = this.props;
        return options && !R.isEmpty(options);
    }

    handleClick = () => {
        const {showOptionsOn, onClick} = this.props;
        const {showOptions} = this.state;

        if (this.hasOptions() && showOptionsOn === 'click') {
            this.setState({showOptions: !showOptions});
        } else {
            onClick();
        }
    };

    handleMouseEnter = () => {
        if (this.hasOptions() && this.props.showOptionsOn === 'hover') {
            this.setState({showOptions: true});
        }
    };

    handleMouseLeave = () => {
        if (this.hasOptions() && this.props.showOptionsOn === 'hover') {
            this.setState({showOptions: false});
        }
    };

    renderOption = option => (
        <div
            key={option.id}
            className="button__option"
            onClick={() => this.props.onClick(option.id)}
        >
            {option.label}
        </div>
    );

    renderOptions = options => {
        const inner = R.prop('$$typeof', R.head(options))
            ? options
            : R.map(this.renderOption, options);

        return (
            <div
                className="button__options"
                onMouseLeave={this.handleMouseLeave}
                onMouseEnter={this.handleMouseEnter}
            >
                {inner}
            </div>
        );
    };

    render() {
        const props = this.props;
        const {link, href, children} = props;
        const {showOptions} = this.state;
        const hasOptions = this.hasOptions();
        const classes = classNames('button', props.className, {
            'button--primary': props.primary,
            'button--secondary': props.secondary,
            'button--danger': props.danger,
            'button--caution': props.caution,
            'button--ghost': props.ghost,
            'button--pinterest': props.pinterest,
            'button--arrow': hasOptions && R.isNil(href),
            'button--back': props.back,
            'button--forward': props.forward,
            'button--mini': props.mini,
            'button--medium': props.medium,
            'button--big': props.big,
            'button--bold': props.bold,
            'button--big-text': props.bigtext,
            'button--no-transform': props.notransform,
        });

        if (link) {
            return (
                <div className="button-container">
                    <Link to={link} className={classes} onClick={props.onClick}>
                        {children}
                    </Link>
                </div>
            );
        }

        if (href) {
            return (
                <div className="button-container">
                    <a href={href} className={classes}>
                        {children}
                    </a>
                </div>
            );
        }

        return (
            <div className="button-container">
                <button
                    disabled={props.disabled}
                    className={classes}
                    onClick={this.handleClick}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                >
                    {children}
                </button>
                {hasOptions && showOptions ? this.renderOptions(props.options) : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/button/index.js